import React from 'react';

export default class InputMaskChildrenWrapper extends React.Component {
  render() {
    const { children, ...props } = this.props;
    return React.cloneElement(children, props);
  }
}
